import { useEffect, useState } from "react";
import Dialog from "src/Components/Dialog/Dialog";
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import Button from "src/Components/Button/Button";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { useTranslation } from "react-i18next";
import { PromoCodeWarning, useAddCouponCredits } from "src/Utils/Hooks/Payments/useAddCouponCredits";
import ErrorMessage from "src/Components/ErrorMessage/ErrorMessage";
interface IAddCouponParams {
  clinicId: string;
  onClose: () => void;
  setInfo: (message: string, type: InfoMessageType) => void;
}
const AddCoupon: React.FC<IAddCouponParams> = ({ onClose, clinicId, setInfo }) => {
  const { addCouponCredits, reqestError, reqestLoading, couponCreditsResponse } = useAddCouponCredits()

  const [disableSubmit, setDisableSubmit] = useState(false);
    const [error, setError] = useState<string>('');
  const [display, setdisplay] = useState('block');
  const { t } = useTranslation();


  const [couponCode, setCouponCode] = useState<string>('');
  useEffect(() => {
    setDisableSubmit(couponCode.trim() === '');
  }, [couponCode]);

  useEffect(() => {
    if (couponCreditsResponse) {
      logger.logInformation(`Added Coupon successfully. coupon code is ${couponCode}, clinicId is ${clinicId}.`)
      
      if(couponCreditsResponse?.warning === PromoCodeWarning.NONE) {
        setInfo(t('CouponAppliedSuccessfully.'), InfoMessageType.success);
        setdisplay('none');
        onClose();
      }
      else if(couponCreditsResponse?.warning === PromoCodeWarning.EXPIRED) {
        setError(t('CouponCodeExpired'));
      }
        else if(couponCreditsResponse?.warning === PromoCodeWarning.INVALID) {
        setError(t('CouponCodeInvalid'));
      }
        else if(couponCreditsResponse?.warning === PromoCodeWarning.ALREADY_USED) {
        setError(t('CouponCodeAlreadyUsed'));
      }
        else if(couponCreditsResponse?.warning === PromoCodeWarning.NOT_ACTIVE) {
        setError(t('CouponCodeNotActive'));
      }
    
    }
    else {
      if (reqestError) {
        logger.logError(`Error occur while adding coupon to clinic. Coupon code is ${couponCode}, clinicId is ${clinicId}.`)
        setInfo(reqestError, InfoMessageType.error);
        onClose();
      }
    }

  }, [couponCreditsResponse, couponCode, clinicId, setInfo, onClose, reqestError, t])
  useEffect(()=> {
    setDisableSubmit(reqestLoading);
},[reqestLoading])

  const addCoponCode = () => {
    setError('');
    addCouponCredits(couponCode, clinicId);
  }
  return (
    <div style={{display: display}}>
      <Dialog
        title={t('AddCoupon')}
        headerAlign='left'
        submitText=""
        onClose={() => onClose()}
        onSubmit={() => {}}
        disableSubmit={disableSubmit}
        hideSubmit={true}
      >
        <div className="label">
            {t('CouponCode')}
        </div>
        <div className="row mt-2">
          <div className="col-8">
            <input
              type="text"
              id="code"
              className="form-control input-box"
              data-testid="copon-code"
              onChange={(e) => {
                setCouponCode(e.target.value);
              }}
              style={
                error
                  ? { border: '1px solid red' }
                  : {}
              }
             
            />
          </div>
          
        <div className="col-4">
            <Button
              backgroundColor='var(--primary-gradient)'
              color='white'
              testId='ok'
              onClick={() => { addCoponCode() }}
              text={t('Apply')}
              height="48px"
              width="182px"
              disable={disableSubmit}
              borderRadius='24px'
            />
          </div>
        {error &&
            <ErrorMessage message={error}></ErrorMessage>
          }
        </div>
      </Dialog>
    </div>
  )
}
export default AddCoupon;